import React, { useEffect, useState } from "react";
import "./Testimonials.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const Testimonials = () => {
  const organizations = [
    {
      id: 1,
      name: "WaterAid Nepal",
      logo: "/assets/images/clients/wateraid-logo.jpg",
      website: "https://www.wateraid.org",
    },
    {
      id: 2,
      name: "UNICEF Nepal",
      logo: "/assets/images/clients/unicef-logo.png",
      website: "https://www.unicef.org/nepal",
    },
    {
      id: 3,
      name: "ENPHO",
      logo: "/assets/images/clients/enpho-logo.png",
      website: "https://enpho.org/",
    },
    {
      id: 4,
      name: "Rupantaran Knowledge Hub",
      logo: "/assets/images/clients/rupantaranknowledge-logo.jpg",
      website: "https://rupantaranknowledgehub.com/",
    },
    {
      id: 5,
      name: "500B Solutions",
      logo: "/assets/images/clients/500B-logo.png",
      website: "https://500bsolutions.com/",
    },
    {
      id: 6,
      name: "Department of Water Supply and Sewerage Management",
      logo: "/assets/images/clients/dwssm-logo.png",
      website: "https://dwssm.gov.np/",
    },
  ];

  const [startIndex, setStartIndex] = useState(0);
  const [logosPerView, setLogosPerView] = useState(4);

  useEffect(() => {
    const updateLogosPerView = () => {
      setLogosPerView(window.innerWidth <= 768 ? 2 : 4);
    };

    updateLogosPerView();

    window.addEventListener("resize", updateLogosPerView);

    return () => {
      window.removeEventListener("resize", updateLogosPerView);
    };
  }, []);

  useEffect(() => {
    const maxStartIndex = Math.max(organizations.length - logosPerView, 0);

    if (startIndex > maxStartIndex) {
      setStartIndex(maxStartIndex);
    }
  }, [logosPerView, startIndex, organizations.length]);

  const nextLogos = () => {
    if (startIndex < organizations.length - logosPerView) {
      setStartIndex((current) => current + 1);
    }
  };

  const prevLogos = () => {
    if (startIndex > 0) {
      setStartIndex((current) => current - 1);
    }
  };

  const visibleLogos = organizations.slice(
    startIndex,
    startIndex + logosPerView,
  );

  return (
    <section className="testimonials-section">
      <div className="container">
        <div className="section-header">
          <h2>Organizations We've Worked With</h2>
          {/* <p>Trusted partners in creating impactful WASH content</p> */}
        </div>

        <div className="logos-carousel">
          <button
            type="button"
            className="carousel-nav prev"
            onClick={prevLogos}
            disabled={startIndex === 0}
            aria-label="Previous organizations"
          >
            <FaArrowLeft aria-hidden="true" />
          </button>

          <div className="logos-container">
            {visibleLogos.map((org) => (
              <a
                key={org.id}
                href={org.website}
                target="_blank"
                rel="noopener noreferrer"
                className="logo-card"
                aria-label={`Visit ${org.name} website`}
              >
                <div className="logo-wrapper">
                  <img src={org.logo} alt={`${org.name} logo`} loading="lazy" />
                </div>

                <p className="logo-name">{org.name}</p>
              </a>
            ))}
          </div>

          <button
            type="button"
            className="carousel-nav next"
            onClick={nextLogos}
            disabled={startIndex + logosPerView >= organizations.length}
            aria-label="Next organizations"
          >
            <FaArrowRight aria-hidden="true" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
